import { motion } from "framer-motion";

const About = () => {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="about"
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-4 col-sm-12">
            <img
              src={require("../assets/rosanne-rojo-profile.png")}
              className="tamara-bio"
              alt="Rosanne Rojo"
            />
          </div>
          <div className="col-xl-7 col-sm-12">
            <div className="row">
              <div className="col-xl-12 col-sm-12">
                <div className="heading">
                  <h5>WHO IS ROSANNE ROJO</h5>
                  <h2>PARTNERING WITH YOU FOR REAL ESTATE SUCCESS</h2>
                  <p>
                    With over 20 years of real estate experience, Rosanne Rojo
                    specializes in probate sales, residential homes, commercial
                    apartment sales, short sales, and senior real estate
                    throughout Orange County. She is known for her strong
                    negotiation skills, market knowledge, and commitment to
                    delivering exceptional client service.
                  </p>
                  <p>
                    Rosanne takes a personalized approach, building lasting
                    relationships and guiding clients through every step of the
                    buying or selling process. Her dedication to communication,
                    integrity, and results helps make each transaction smooth and
                    stress-free.
                  </p>
                  <p>
                    Whether buying, selling, or relocating, Rosanne is focused on
                    helping her clients achieve their real estate goals with
                    confidence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
